{
  "Announcements": "Anuncios",
  "MarkAllAsRead": "Marcar todo como leído",
  "NoLinkNotification": "No hay vínculos disponibles para esta notificación",
  "Notification": "Notificaciones",
  "ViewAll": "Ver todos"
}
